export default {
    title: '{school} {grade}年级 {className}班 <span>({onlineCount}/{totalCount})</span>',
    onlineCount: '正在上课 <span>({count}名)</span>',
    offlineCount: '未参与 <span>({count}名)</span>',
    selectedStudents: '已选择{count}名',
    giveStar: ({ values }: { values: { isAll: boolean } }) => {
        const { isAll } = values;

        if (isAll) {
            return '给<span>所有学生</span>赠送星星';
        }

        return '<span>赠送星星</span>';
    },
    giveStarConfirm: '确定要给<strong>{label}</strong>赠送表扬星吗？',
    comment: {
        '0': '做得非常好',
        '1': '积极参与了',
        '2': '与同学们合作得很好',
        '3': '讲解得很好',
        '4': '回答得很有逻辑',
        '5': '表达能力很出色',
        '6': '发言很精彩',
        '7': '回答很有创意',
        '8': '创造力突出',
    },
};
